import axiosClient from '../axiosClient';

const dashboardService = {
  async getDashboardData() {
    try {
      const response = await axiosClient.get('/dashboard');
      console.log(response.data.data);
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || 'errors.failed_to_fetch_data');
    }
  },

  async getTimeOverview() {
    try {
      const response = await axiosClient.get('/dashboard/time-overview');
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || 'errors.failed_to_fetch_data');
    }
  },

  async getPhotosOverview() {
    try {
      const response = await axiosClient.get('/dashboard/photos-overview');
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || 'errors.failed_to_fetch_data');
    }
  },

  async getPaperOverview() {
    try {
      const response = await axiosClient.get('/dashboard/paper-overview');
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || 'errors.failed_to_fetch_data');
    }
  },

  async getLogOverview() {
    try {
      const response = await axiosClient.get('/dashboard/log-overview');
      return response.data.data;
    } catch (error) {
      return Promise.reject(error.response?.data?.message || 'errors.failed_to_fetch_data');
    }
  }
};

export default dashboardService;
